import type { Action } from '@ngrx/store';
import { DialogTag } from '@pixelgenau/ngx-dialog';

export interface Button {
    identifier: string;
    label: string;
    action?: Action;
}

export interface EditConfirmDialogData {
    headline: string;
    copy: string;
    info?: string;
    buttons: Button[];
}

export const EditConfirmDialogTag = new DialogTag<EditConfirmDialogData, string | undefined>(
    'edit-confirm-dialog',
    () => import('./confirm.component'),
);
